const formatDuration = minutes => {
  const hours = Math.floor(minutes / 60);
  const remainingMinutes = Math.ceil(minutes % 60);

  return hours > 0
    ? `${hours} hr${hours > 1 ? 's' : ''}${remainingMinutes > 0 ? ` ${remainingMinutes} mins` : ''}`
    : `${remainingMinutes} mins`;
};

/**
 * Format duration in minutes to short human-readable string
 * @param {number} minutes - Duration in minutes
 * @returns {string} Formatted duration (e.g., "2h 30m", "45m", "0m")
 */
export const formatDurationShort = minutes => {
  if (minutes === null || minutes === undefined) return '';

  const hours = Math.floor(minutes / 60);
  const mins = Math.floor(minutes % 60);

  if (hours > 0) {
    return `${hours}h ${mins > 0 ? `${mins}m` : ''}`.trim();
  }
  return `${mins}m`;
};

export default formatDuration;
